import { useCallback } from 'react';
import { CuboidBase, CuboidDataHandlers, StyledCuboid } from '../types';

export const useSaveCuboid = <CuboidT extends CuboidBase>(
  dataHandlers: CuboidDataHandlers<CuboidT>
) => {
  const saveCuboid = useCallback(
    (cuboid: StyledCuboid<CuboidT>) => {
      const { position, rotation, scale } = cuboid;

      const newCuboidData = { ...cuboid.cuboidData, position, rotation, scale };

      dataHandlers.addUpdateCuboid(newCuboidData);
    },
    [dataHandlers]
  );

  return saveCuboid;
};
